import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { API_URL, UPLOADS_API_URL } from "./config";

const SoftworksReceipt = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const {
    customer = {},
    selectedGoods,
    totalAmount,
    operatorName,
    branchName,
    shiftId,
    companyDetails,
    branchDetails,
  } = location.state;

  // Log the received data for debugging
  console.log("Receipt Data:", {
    customer,
    selectedGoods,
    totalAmount,
    operatorName,
    branchName,
    shiftId,
    companyDetails,
    branchDetails,
  });

  const handlePrint = () => {
    window.print();
  };

  return (
    <div
      style={{
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginTop: 100,
      }}
    >
      <div
        style={{
          width: "100%",
          backgroundColor: "white",
          display: "flex",
          flexDirection: "column",
          overflowY: "auto",
          padding: "20px",
        }}
      >
        <div style={{ display: "flex", justifyContent: "center" }}>
          <img
            src={`${
              companyDetails.horizontal_logo
                ? `${UPLOADS_API_URL}/${companyDetails.horizontal_logo.replace(
                    /\\/g,
                    "/"
                  )}`
                : "/assets/images/default-logo.png"
            }`}
            alt={`${companyDetails.trading_name} Logo`}
            style={{
              width: "100%",
              height: "auto",
              maxHeight: "150px",
              objectFit: "contain",
              marginBottom: "10px",
            }}
          />
        </div>

        <div className="modal-header">
          <div style={{ textAlign: "center", width: "100%" }}>
            <h2 style={{ margin: "0", color: "blue" }}>
              {companyDetails.trading_name}
            </h2>

            <div>
              {/* Branch Details Section */}
              {branchDetails.length > 0 && (
                <div style={{ marginTop: "20px" }}>
                  <p>
                    <strong>Branch Name:</strong> {branchDetails[0].branch_name}
                  </p>
                </div>
              )}
            </div>

            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <img
                    src={`${
                      companyDetails.sub_logo
                        ? `${UPLOADS_API_URL}/${companyDetails.sub_logo.replace(
                            /\\/g,
                            "/"
                          )}`
                        : "/assets/images/default-logo.png"
                    }`}
                    alt={`${companyDetails.name} Logo`}
                    style={{
                      width: "100%",
                      height: "auto",
                      maxHeight: "150px",
                      objectFit: "contain",
                      marginBottom: "10px",
                    }}
                  />
                </div>
              </div>

              <div>
                <div style={{ flex: 1, textAlign: "right" }}>
                  <p style={{ margin: "2px 0", fontSize: "0.9rem" }}>
                    Date: <span>{new Date().toLocaleDateString()}</span>
                  </p>
                  <p style={{ margin: "2px 0", fontSize: "0.9rem" }}>
                    Receipt #: <span>{shiftId}</span>
                  </p>
                  <p style={{ margin: "2px 0", fontSize: "0.9rem" }}>
                    Customer ID: <span>{customer.company_id || "N/A"}</span>
                  </p>
                </div>
              </div>
            </div>

            <hr style={{ backgroundColor: "blue", height: "2px" }} />

            <div className="d-flex justify-content-between align-items-start">
              <div style={{ display: "flex", flexDirection: "row" }}>
                <div style={{ textAlign: "left" }}>
                  <div style={{ flex: 1 }}>
                    <h3 style={{ fontSize: "1.2rem" }}>
                      Received From: {customer.name || "N/A"}
                    </h3>
                    <p style={{ fontSize: "0.9rem" }}>
                      {customer.address || "N/A"}
                    </p>
                    <p style={{ fontSize: "0.9rem" }}>
                      {customer.phone_number1 || "N/A"} /{" "}
                      {customer.phone_number2 || "N/A"}
                    </p>
                  </div>
                </div>

                <div style={{ marginLeft: 30 }}>
                  <h4>Shipping To:</h4>
                </div>
              </div>

              <div style={{ textAlign: "center", flex: 1 }}>
                <h2
                  className="invoice-text"
                  style={{
                    color: "red",
                    fontSize: "1.5rem",
                    fontWeight: "bold",
                    textDecoration: "underline",
                  }}
                >
                  RECEIPT
                </h2>
              </div>
            </div>

            <hr style={{ backgroundColor: "green", height: "2px" }} />
          </div>
        </div>

        {/* Receipt Items Table */}
        <div
          className="modal-body"
          style={{ overflowY: "auto", backgroundColor: "white" }}
        >
          <div className="invoice-container" style={{ padding: "20px" }}>
            <div style={{ overflowX: "auto" }}>
              <table
                className="table table-striped table-bordered"
                style={{
                  backgroundColor: "white",
                  marginTop: "20px",
                  fontSize: "0.9rem",
                  width: "100%",
                }}
              >
                <thead>
                  <tr style={{ backgroundColor: "skyblue" }}>
                    {" "}
                    <th>Item</th>
                    <th>Description</th>
                    <th>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedGoods && selectedGoods.length > 0 ? (
                    selectedGoods.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item.product_name}</td>
                        <td>${item.total.toFixed(2)}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="3" style={{ textAlign: "center" }}>
                        No items selected.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            <div
              className="invoice-summary"
              style={{
                textAlign: "right",
                marginTop: "20px",
                backgroundColor: "white",
                fontSize: "0.9rem",
              }}
            ></div>
          </div>
        </div>

        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div style={{}}>
            <img
              src={`${
                companyDetails.footer_logo
                  ? `${UPLOADS_API_URL}/${companyDetails.footer_logo.replace(
                      /\\/g,
                      "/"
                    )}`
                  : "/assets/images/default-logo.png"
              }`}
              alt={`${companyDetails.trading_name} Logo`}
              style={{
                width: "100%",
                height: "auto",
                maxHeight: "180px",
                objectFit: "contain",
                alignSelf: "left",
              }}
            />
          </div>

          <div style={{ display: "flex", flexDirection: "row", alignSelf: 'right' }}>
            <div style={{ textAlign: "right" }}>
              <p>
                Total:{" "}
                <span style={{ backgroundColor: "skyblue", marginLeft: 20 }}>
                  ${totalAmount.toFixed(2)}
                </span>
              </p>
              <p>
                Sale Total:{" "}
                <span
                  style={{ backgroundColor: "skyblue", marginLeft: 70 }}
                ></span>
              </p>
              <p>
                Total:{" "}
                <span style={{ backgroundColor: "skyblue", marginLeft: 20 }}>
                  ${totalAmount.toFixed(2)}
                </span>
              </p>
            </div>
          </div>
        </div>


        

        <div style={{ display: "flex"}}>
          <div style={{ alignContent: "center" }}>
            {branchDetails.length > 0 && (
              <div style={{ marginTop: "20px", alignContent: "end" }}>
                <strong>
                  {" "}
                  {branchDetails[0].branch_name}
                  <br></br>
                </strong>
                {companyDetails.address} <br></br>
                Phone: {companyDetails.phone_number1}
                <br></br>
                {branchDetails[0].branch_location} <br></br>
                {branchDetails[0].branch_city}
              </div>
            )}
          </div>

          <div style={{}}>
            <img
              src={`${
                companyDetails.document_footer_symbol
                  ? `${UPLOADS_API_URL}/${companyDetails.document_footer_symbol.replace(
                      /\\/g,
                      "/"
                    )}`
                  : "/assets/images/default-logo.png"
              }`}
              alt={`${companyDetails.trading_name} Logo`}
              style={{
                width: "100%",
                height: "auto",
                maxHeight: "250px",
                objectFit: "contain",
                marginBottom: "10px",
                alignSelf: "left",
              }}
            />
          </div>
        </div>

        {/* Footer with Actions */}
        <div className="modal-footer" style={{ marginBottom: 45 }}>
          <button className="btn btn-danger" onClick={() => navigate(-1)}>
            Cancel
          </button>
          <button className="btn btn-primary mx-2" onClick={handlePrint}>
            Print Receipt
          </button>
        </div>
      </div>
    </div>
  );
};

export default SoftworksReceipt;
